import { render } from "./MyWork.vue?vue&type=template&id=2938ea44&scoped=true"
import script from "./MyWork.vue?vue&type=script&lang=js"
export * from "./MyWork.vue?vue&type=script&lang=js"

import "./MyWork.vue?vue&type=style&index=0&id=2938ea44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2938ea44"]])

export default __exports__